export default __webpack_public_path__ + "static/media/icons-enroll.28dc9697.svg";